<template>
  <div class="media">
    <div class="layout row">
      <div class="media-aside media-menu">
        <v-list dense class="transparent">
          <template v-for="(setting, index) in settings">
            <div v-if="setting.show" :key="index">
              <v-subheader v-if="setting.subheader" :key="index">{{
                setting.title
              }}</v-subheader>
              <v-list-tile v-else :key="index" :to="setting.to">
                <v-list-tile-action v-if="setting.icon">
                  <v-icon>{{ setting.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ setting.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
          </template>
        </v-list>
      </div>
      <div v-if="!isLoading" class="media-content flex transparent" style="overflow: hidden">
        <!--router-view name="MediaList"></router-view-->
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { checkUserPermissions } from "@/utils/userPermissionsControl";
import { STATE_PERMISSIONS_BY_CATEGORY, STORE_PERMISSIONS_NAME } from "@/store_constants/permissions";
import { ACTION_GET_ALL_ROLES, STORE_ROLES_NAME } from "@/store_constants/roles";

export default {
  data() {
    return {
      isLoading: true
    }
  },
  async created() {
    if (this.canShowSiteUsers() || this.canShowSiteRoles()) {
      await this.getRoles();
    }

    this.isLoading = false;
  },
  computed: {
    ...mapState(STORE_PERMISSIONS_NAME, {
      permissionsByCategory: STATE_PERMISSIONS_BY_CATEGORY
    }),
    settings() {
      return [
        { subheader: true, title: "User Settings", show: this.canShowUserSettings() },
        {
          icon: "mdi-account",
          title: "My profile",
          to: { name: "My Profile" },
          show: this.canShowUserSettings()
        },
        {
          icon: "mdi-key-outline",
          title: "My permissions",
          to: { name: "My Permissions" },
          show: this.canShowUserSettings()
        },
        { subheader: true, title: "Site Settings", show: this.canShowSiteSettings() },
        {
          icon: "mdi-account-group",
          title: "Users",
          to: { name: "Site Users" },
          show: this.canShowSiteUsers()
        },
        {
          icon: "mdi-shield-account-outline",
          title: "Roles",
          to: { name: "Site Roles" },
          show: this.canShowSiteRoles()
        },
        {
          icon: "mdi-library-shelves",
          title: "Libraries",
          to: { name: "Site Libraries" },
          show: this.canShowSiteLibraries()
        }
      ];
    }
  },
  methods: {
    ...mapActions(STORE_ROLES_NAME, {
      getRoles: ACTION_GET_ALL_ROLES
    }),
    canShowUserSettings() {
      const permissions = [this.permissionsByCategory.settings.viewProfile];
      return checkUserPermissions(permissions);
    },
    canShowSiteSettings() {
      return this.canShowSiteUsers() || this.canShowSiteRoles() || this.canShowSiteLibraries();
    },
    canShowSiteUsers() {
      const permissions = [this.permissionsByCategory.userManagement.userAccountManager];
      return checkUserPermissions(permissions);
    },
    canShowSiteRoles() {
      const permissions = [this.permissionsByCategory.userManagement.manageRoles];
      return checkUserPermissions(permissions);
    },
    canShowSiteLibraries() {
      const permissions = [this.permissionsByCategory.contentManagement.manageLibraries];
      return checkUserPermissions(permissions);
    },
  }
};
</script>
<style scoped>
.media-menu {
  min-width: 260px;
  border-right: 1px solid #eee;
  min-height: calc(100vh - 50px - 64px);
}

.media-detail {
  min-width: 300px;
  border-left: 1px solid #eee;
}
</style>
